// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1-xgk","errorLogs":"styles_errorLogs__eL-qF"};